const getters = {
	version(state) {
		return state.version;
	}
};

export default getters;